import { machineCatalogActions } from "../../constants/actionTypes";

const INITIAL_STATE = {
  catalogsList: {},
  cloudTemplates: {},
  actionData: "",
  cloneMessage: "",
  cloneError: "",
  deleteError: "",
  statusChange: "",
  publicCloudTemplateError: false,
  catalogSkuCsv: "",
  csvError: "",
  planMapData: "",
  planMapError: "",
  planMapUpdateData: "",
  planMapRetriveData: "",
  markCatalogB2c: "",
  markedForB2CMessage: "",
  changeCatalogStatusLoading: false,
  publicCloudFilterData: ""
};

const machineCatalog = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    // case machineCatalogActions.SET_CATALOG_LIST_DATA: {
    //   const res = state?.catalogsListTotal?.results || [];
    //   const newRes = action?.payload?.results || [];
    //   const results = [...res, ...newRes];
    //   console.log("results:=============", results);
    //   return {
    //     ...state,
    //     cloneError: "",
    //     deleteError: "",
    //     catalogsList: { ...action?.payload },
    //     catalogsListTotal: {
    //       ...action?.payload,
    //       results: results,
    //     },
    //     actionData: "",
    //   };
    // }

    case machineCatalogActions.SET_CATALOG_LIST_DATA: {
      const res = state?.catalogsListTotal?.results || [];
      const newRes = action?.payload?.results || [];
      const mergedResults = [...res, ...newRes];
      const uniqueResultsMap = new Map();
      mergedResults.forEach((item) => {
        uniqueResultsMap.set(item.id, item);
      });
      const uniqueResults = Array.from(uniqueResultsMap.values());
      return {
        ...state,
        cloneError: "",
        deleteError: "",
        catalogsList: { ...action?.payload },
        catalogsListTotal: {
          ...action?.payload,
          results: uniqueResults,
        },
        actionData: "",
      };
    }
    case machineCatalogActions.FETCH_CLOUD_TEMPLATES_SUCCESS: {
      const res = state?.cloudTemplates?.results || [];
      const newRes = action?.payload?.results || [];
      const results = [...res, ...newRes];
      return {
        ...state,
        cloudTemplates: { ...action?.payload },
        cloudTemplateTotal: {
          ...action?.payload,
          results: results,
        },
        actionDataPublic: "",
        publicCloudTemplateError: false,
      };
    }
    case machineCatalogActions.RESET_CLONE_ERROR:
      return { ...state, cloneError: action?.payload };
    case machineCatalogActions.RESET_DELETE_ERROR:
      return { ...state, delete: action?.payload };
    case machineCatalogActions.SET_CATALOG_LIST_ERROR:
      return {
        ...state,
        catalogsList: {},
        actionData: action?.payload,
      };

    case machineCatalogActions.FETCH_CLOUD_TEMPLATES_ERROR:
      return {
        ...state,
        cloudTemplates: {},
        actionDataPublic: action?.payload,
        publicCloudTemplateError: true,
      };

    case machineCatalogActions.DELETE_CATALOG_SUCCESS:
      return {
        ...state,
        actionDataMessage: action.payload,
        // catalogsList: {},
        deleteError: "",
        deleteMessage: action?.payload,
      };

    case machineCatalogActions.DELETE_CATALOG_ERROR:
      return {
        ...state,
        deleteError: action?.payload,
      };

    case machineCatalogActions.SUCCESS_EXPORT_CATALOG:
      return {
        ...state,
        catalogSkuCsv: action?.payload,
      };

    case machineCatalogActions.ERROR_EXPORT_CATALOG:
      return {
        ...state,
        csvError: action?.payload,
      };
    case machineCatalogActions.CHANGE_CATALOG_STATUS:
      return {
        ...state,
        changeCatalogStatusLoading: true
      };
    case machineCatalogActions.CHANGE_CATALOG_STATUS_SUCCESS:
      return {
        ...state,
        actionDataMessage: action.payload,
        changeStatusMessage: action.payload,
        changeStatusError: "",
        changeCatalogStatusLoading: false
      };
    case machineCatalogActions.CLONE_ERROR:
      return {
        ...state,
        cloneError: true,
      };
    case machineCatalogActions.SET_CLONE_ERROR:
      return {
        ...state,
        actionDataMessage: action?.payload,
        cloneError: true,
      };

    case machineCatalogActions.CHANGE_CATALOG_STATUS_ERROR:
      return {
        ...state,
        catalogsList: { ...state.catalogsList },
      };

    case machineCatalogActions.CLONE_SUCCESS:
      return { ...state, cloneMessage: action?.payload, cloneError: "" };
    case machineCatalogActions.SET_CLONE_SUCCESS:
      return {
        ...state,
        cloneMessage: action?.payload,
        cloneError: "",
      };
    case machineCatalogActions.RESET_CATALOG_LIST:
      return {
        ...INITIAL_STATE,
        actionData: action?.payload,
      };

    case machineCatalogActions.SUCCESS_CREATE_CATALOG_PLAN_MAP:
      return {
        ...state,
        planMapData: action?.payload,
      };

    case machineCatalogActions.SUCCESS_UPDATE_CATALOG_PLAN_MAP:
      return {
        ...state,
        planMapUpdateData: action?.payload,
      };

    case machineCatalogActions.SUCCESS_RETRIVE_CATALOG_PLAN_MAP:
      return {
        ...state,
        planMapRetriveData: action?.payload,
      };

    case machineCatalogActions.SUCCESS_MARKED_CATALOG_B2C:
      return {
        ...state,
        markCatalogB2c: action?.payload,
        markedForB2CMessage: action?.payload,
      };

    case machineCatalogActions.ERROR_CREATE_CATALOG_PLAN_MAP:
    case machineCatalogActions.ERROR_UPDATE_CATALOG_PLAN_MAP:
    case machineCatalogActions.ERROR_RETRIVE_CATALOG_PLAN_MAP:
    case machineCatalogActions.ERROR_MARKED_CATALOG_B2C:
      return {
        ...state,
        planMapError: action?.payload,
      };

    case machineCatalogActions.SET_PUBLIC_CLOUD_ACTION:
      return {
        ...state,
        publicCloudFilterData: action?.payload,
      };

    default:
      return state;
  }
};

export default machineCatalog;
